<script setup>
import {onMounted} from "vue";
import {useOpendataStore} from "@/stores/opendata.store";

const props = defineProps({
  appConfig: Object
});

const opendataStore = useOpendataStore();

onMounted(async () => {
  await opendataStore.getGroups();
});
</script>
<template>
  <header id="header" data-plugin-options="{'stickyEnabled': true, 'stickyEnableOnBoxed': true, 'stickyEnableOnMobile': false, 'stickyStartAt': 108, 'stickyStartAt': 108, 'stickySetTop': '-109px', 'stickyChangeLogo': true}">
  <div class="header-body">
    <div class="header-container container">
      <div class="header-row">
        <div class="header-column">
          <div class="header-row">
            <div class="header-logo">
              <router-link to="/">
                <img alt="DBD Logo" width="165" height="157" data-sticky-width="82" data-sticky-height="78" data-sticky-top="92" :src="require('@/assets/img/DBD-100-4200.jpg')">
              </router-link>
            </div>
          </div>
        </div>
        <div class="header-column justify-content-end">
          <div class="header-row pt-3">
            <nav class="header-nav-top">
              <ul class="nav nav-pills">
                <li class="nav-item nav-item-anim-icon d-none d-md-block">
                  <a class="nav-link" href="#"><i class="fas fa-angle-right"></i> ติดต่อเรา</a>
                </li>
                <li class="nav-item nav-item-left-border">
                  <span class="ws-nowrap"><i class="fas fa-phone"></i> {{ props.appConfig?.hotline }}</span>
                </li>
              </ul>
            </nav>
          </div>
          <div class="header-row">
            <ul class="header-extra-info d-flex align-items-center">
              <li class="d-none d-md-inline-flex">
                <div class="header-extra-info-text">
                  <label>เวลาทำการ</label>
                  <strong>{{ props.appConfig?.workingDate }}</strong>
                </div>
              </li>
              <li class="d-none d-sm-inline-flex">
                <div class="header-extra-info-text">
                  <label>อีเมล</label>
                  <strong><a :href="`mailto:${props.appConfig?.mail}`">{{ props.appConfig?.mail }}</a></strong>
                </div>
              </li>
            </ul>
          </div>
          <div class="header-row">
            <div class="header-nav pt-1">
              <div class="header-nav-main header-nav-main-effect-1 header-nav-main-sub-effect-1">
                <nav class="collapse">
                  <ul class="nav nav-pills" id="mainNav">
                    <li class="dropdown">
                      <router-link to="/" class="dropdown-item dropdown-toggle active">
                        <span class="material-symbols-outlined">home</span>
                      </router-link>
                    </li>
                    <li class="dropdown">
                      <a class="dropdown-item dropdown-toggle" :href="'/'">
                        ชุดข้อมูล
                      </a>
                      <ul class="dropdown-menu">
                        <li class="dropdown-submenu" v-for="group in opendataStore.groups" :key="group?.id">
                          <a class="dropdown-item" href="#">{{ group?.name }}</a>
                          <ul class="dropdown-menu" v-if="group?.datasetDtos.length > 0">
                            <li v-for="dataset in group?.datasetDtos" :key="dataset?.id">
                              <router-link :to="`/opendata/${dataset?.id}`" class="dropdown-item">
                                {{ dataset?.title }}
                              </router-link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li class="dropdown">
                      <router-link to="/manual" class="dropdown-item dropdown-toggle">
                        คำแนะนำการใช้งาน
                      </router-link>
                    </li>
                    <li class="dropdown">
                      <router-link to="/faq" class="dropdown-item dropdown-toggle">
                        คำถามที่พบบ่อย
                      </router-link>
                    </li>
                  </ul>
                </nav>
              </div>
              <button class="btn header-btn-collapse-nav" data-bs-toggle="collapse" data-bs-target=".header-nav-main nav">
                <i class="fas fa-bars"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </header>
</template>
